import React from 'react'
import { Skeleton, type SkeletonProps } from '@mantine/core'

export type AppSkeletonProps = SkeletonProps

/** Standard loading placeholder with md radius. */
export default function AppSkeleton ({ radius = 'md', ...props }: AppSkeletonProps) {
  return <Skeleton radius={radius} {...props} />
}
